<template>
    <k-panel v-if="tranche.subscriptionEnabled">
        <form autocomplete="off" v-if="tranche.subscriptionEnabled">
            <div class="flex flex-row">
                <a-input v-model="form.amount"
                         :disabled="!investorActive"
                         id="amount" type="text" placeholder="Enter amount to invest"
                         class="mr-1"
                         size="large">
                </a-input>
                <a-button @click="submitInquiry" type="primary" size="large"
                          class="offer-btn"
                          :disabled="form.amount < 1" style="width: 200px; padding: 0">
                    {{ $t("getOffer") }}
                </a-button>
            </div>
            <div class="text-xs text-gray-700 mt-1">
                Min. amount {{ tranche.nominalValue | currencyFormat(tranche.currencySymbol) }}
                ,
                max {{ tranche.principalAvailable | currencyFormat(tranche.currencySymbol) }}
            </div>
        </form>
        <k-alert class="mt-6" v-if="offer && offer.hasErrors">
            <template slot="description">
                {{ $t("getOfferProblem") }}
                <br>
                {{ offer.errorMsg }}
            </template>

        </k-alert>
        <div v-if="offer && !offer.hasErrors" class="bg-gray-200 mt-2 border p-2">
            <k-panel-row>
                <div slot="left">{{ $t("principal") }}</div>
                <div slot="right">{{ offer.principal | currencyFormat(tranche.currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">{{ $t("accruedInterest") }}</div>
                <div slot="right">{{ offer.accruedInterest | currencyFormat(tranche.currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">{{ $t("subscriptionFee") }}</div>
                <div slot="right">{{ offer.investorSubscriptionFee | currencyFormat(tranche.currencySymbol) }}</div>
            </k-panel-row>
            <k-panel-row v-if="offer.discountedPrice">
                <div slot="left">{{ $t("discountedPrice") }}</div>
                <div slot="right" class="text-primary-500 font-semibold">
                    {{ offer.discountedPrice | currencyFormat(tranche.currencySymbol) }}
                </div>
            </k-panel-row>
            <k-panel-row>
                <div slot="left">{{ $t("fundsToCommit") }}</div>
                <div slot="right" class="text-primary-500 font-semibold">
                    {{ offer.totalCostForInvestor | currencyFormat(tranche.currencySymbol) }}
                </div>
            </k-panel-row>
            <a-checkbox
                id="acceptTerms"
                v-model="form.acceptTerms"
            >
                {{ $t("iAccept") }}
                <a @click="investmentTerms"
                   target="_blank"
                   class="text-primary-500">
                    {{ $t("investmentTerms") }}</a>
            </a-checkbox>
            <a-checkbox
                id="acceptLetterOfWaiver"
                v-model="form.acceptLetterOfWaiver"
                v-if="tranche.internal"
                style="margin-left: 0;">
                {{ $t("iAccept") }}
                <a @click="letterOfWaiver"
                   target="_blank"
                   class="text-primary-500">{{ $t("letterOfWaiver") }}
                </a>
            </a-checkbox>
            <div class="flex justify-between mt-3 text-gray-500">
                <a-button @click="commitFunds"
                          :disabled="offer.principal <= 0 || !form.acceptTerms || (tranche.internal && !form.acceptLetterOfWaiver) || offer.hasErrors"
                          type="primary"
                          size="large"
                >
                    {{ $t("commit") }}
                </a-button>
            </div>
        </div>
    </k-panel>
</template>

<script>
export default {
    props: {
        offer: {
            type: Object
        },
        tranche: {
            type: Object,
            required: true
        },
        investment: {
            type: Object
        },
        investorActive: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            form: {
                trancheUuid: this.tranche.uuid,
                amount: null,
                acceptTerms: false,
                acceptLetterOfWaiver: false
            }
        };
    },
    methods: {
        async submitInquiry() {
            this.$emit('on-inquiry', this.form);
        },
        async commitFunds() {
            this.$emit('on-commit', {
                trancheUuid: this.form.trancheUuid,
                amount: this.offer.principal
            });
        },
        async investmentTerms() {
            this.$emit('on-investment-terms', this.form);
        },
        async letterOfWaiver() {
            this.$emit('on-letter-of-waiver', this.form);
        }
    }
};
</script>

<style scoped>
.offer-btn:disabled {
    @apply bg-primary-500 text-white border-none;
}
</style>
